import {useEffect, useState} from 'react'
import {QueryStatus, QueryStatusType} from 'src/types'
import {OperacionLCSLHPTI} from "../types/types";
import { HttpLCSLHPTI } from '../api/httpLCSLSHPTI';

type UseOperacionResult<TOperacion> = {
    status: QueryStatusType
    operacion: TOperacion | undefined
}

export const useOperacionLCSLHPTI: (idOperacion: number) => UseOperacionResult<OperacionLCSLHPTI> = (idOperacion: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [operacion, setOperacion] = useState<OperacionLCSLHPTI>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpLCSLHPTI.get(idOperacion)
            .then(data => {
                setOperacion(data)
                setStatus(QueryStatus.Success)
            })
            .catch(() => setStatus(QueryStatus.Error))
    }, [idOperacion])

    return {status, operacion}
}


